
const mapProductSummaryToTable = (productSummary, totalLeadCount, translation) => {
    const dataCols = [
        {
            id: 'leadType', numeric: false, disablePadding: false, label: translation.TYPE_OF_LEAD, defaultSorting: false,
        },
        {
            id: 'share', numeric: true, disablePadding: false, label: translation.SHARE, defaultSorting: false,
        },
        {
            id: 'count', numeric: true, disablePadding: false, label: translation.COUNT, defaultSorting: true,
        },
    ];

    const dataRows = productSummary.map((summary) => {
        const id = summary.name;
        const share = Math.round(summary.count * 100 / totalLeadCount);

        return {
            id,
            leadType: translation.PRODUCT_KEYS[summary.name] || summary.name,
            share: share < 1 ? '< 1%' : `${share}%`,
            count: summary.count,
        };
    });

    return {
        dataCols,
        dataRows,
    };
};

export default mapProductSummaryToTable;
